var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[(_vm.news=='ai')?_c('file-up-load',{attrs:{"editInfo":_vm.params,"applyType":_vm.$route.query.applyType,"news":_vm.news}}):_c('file-up-load1',{attrs:{"editInfo":_vm.params,"applyType":_vm.$route.query.applyType,"news":_vm.news}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }